import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from '@reduxjs/toolkit/query/react';
import ProfileSlice from "./Fetures/ProfileSlice";
import EmpListSlice from "./Fetures/EmpListSlice";
import DegignationSlice from "./ThunkApiCall/DesignationSlice";
import EmpbreakSlice from "./ThunkApiCall/EmpbreakSlice";
import AttendanceSlice from "./ThunkApiCall/AttendanceSlice";
import TodayempSlice from "./ThunkApiCall/TodayempSlice";
import ViewEmployeeSlice from "./ThunkApiCall/ViewEmployeeSlice";

let initialState = {};
let store = configureStore(
    {
        reducer: {
            profile: ProfileSlice,
            employeelist: EmpListSlice,
            designationdata: DegignationSlice,
            empbreakdata: EmpbreakSlice,
            attendancelist: AttendanceSlice,
            todayemployeelist: TodayempSlice,
            viewempoyee: ViewEmployeeSlice,
        },
    },
    initialState,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() // Corrected Redux DevTools extension check
);

setupListeners(store.dispatch);

export default store;
